module.exports = __webpack_public_path__ + "static/media/jane-right.4379b810.svg";